
"use strict";

// ============================================================
// VARIABLES
// ============================================================

let registrosDepartamento = [];

let empleadosDepartamento = [];


// ============================================================
// RUTA DEL MODULO
// ============================================================

const RUTA_DEPARTAMENTO =
    "/departamento";


// ============================================================
// INICIALIZAR MODULO
// ============================================================

export async function inicializarDepartamento() {

    console.log(
        "=============================================="
    );

    console.log(
        "🚀 INICIANDO MÓDULO DEPARTAMENTO TECNOLÓGICO"
    );

    console.log(
        "=============================================="
    );

    await cargarDatos();

    activarBuscador();

    activarEventoEmpleado();

    activarFormularioDepartamento();

    activarFormularioEditarDepartamento();

    activarFormularioEliminarDepartamento();

}


// ============================================================
// CARGAR DATOS
// ============================================================

async function cargarDatos() {

    try {

        console.log(
            "📋 CARGANDO DEPARTAMENTOS Y EMPLEADOS..."
        );


        const respuesta =
            await fetch(
                `${RUTA_DEPARTAMENTO}/listar`,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        console.log(
            "📦 RESPUESTA /departamento/listar:",
            resultado
        );


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.error ||
                "No se pudieron cargar los departamentos."
            );

        }


        // ====================================================
        // DEPARTAMENTOS
        // ====================================================

        registrosDepartamento =
            Array.isArray(resultado.data)
                ? resultado.data
                : [];


        // ====================================================
        // EMPLEADOS
        //
        // Acepta:
        // resultado.empleados
        // resultado.dataEmpleados
        // resultado.empleadosDepartamento
        // resultado.listaEmpleados
        // ====================================================

        if (
            Array.isArray(resultado.empleados)
        ) {

            empleadosDepartamento =
                resultado.empleados;

        }
        else if (
            Array.isArray(resultado.dataEmpleados)
        ) {

            empleadosDepartamento =
                resultado.dataEmpleados;

        }
        else if (
            Array.isArray(
                resultado.empleadosDepartamento
            )
        ) {

            empleadosDepartamento =
                resultado.empleadosDepartamento;

        }
        else if (
            Array.isArray(
                resultado.listaEmpleados
            )
        ) {

            empleadosDepartamento =
                resultado.listaEmpleados;

        }
        else {

            empleadosDepartamento = [];

        }


        // ====================================================
        // NORMALIZAR EMPLEADOS
        // ====================================================

        empleadosDepartamento =
            normalizarEmpleados(
                empleadosDepartamento
            );


        console.log(
            "=============================================="
        );

        console.log(
            "📊 DEPARTAMENTOS:",
            registrosDepartamento.length
        );

        console.log(
            "👥 EMPLEADOS:",
            empleadosDepartamento.length
        );

        console.log(
            "=============================================="
        );


        // ====================================================
        // CARGAR DROPDOWN
        // ====================================================

        cargarDropdownEmpleados();


        // ====================================================
        // TABLA
        // ====================================================

        renderizarTabla();


        // ====================================================
        // RESUMEN
        // ====================================================

        actualizarResumen();

    }
    catch (error) {

        console.error(
            "❌ ERROR AL CARGAR DEPARTAMENTOS:",
            error
        );


        empleadosDepartamento = [];

        registrosDepartamento = [];


        cargarDropdownEmpleados();

        mostrarErrorTabla(
            error.message
        );

        actualizarResumen();

    }

}


// ============================================================
// NORMALIZAR EMPLEADOS
// ============================================================

function normalizarEmpleados(
    empleados
) {

    if (!Array.isArray(empleados)) {

        return [];

    }


    const mapa =
        new Map();


    empleados.forEach(
        function (empleado) {

            if (!empleado) {

                return;

            }


            const id =
                empleado.IDEMPLEADO ??
                empleado.idEmpleado ??
                empleado.IdEmpleado ??
                empleado.idempleado;


            if (
                id === undefined ||
                id === null ||
                id === ""
            ) {

                return;

            }


            const nombre =
                empleado.NOMBREEMPLEADO ??
                empleado.nombreEmpleado ??
                empleado.NombreEmpleado ??
                empleado.nombre ??
                "";


            const dpi =
                empleado.DPI ??
                empleado.dpi ??
                "";


            const direccion =
                empleado.DIRECCION ??
                empleado.direccion ??
                "";


            const puesto =
                empleado.NOMBREPUESTO ??
                empleado.nombrePuesto ??
                empleado.NombrePuesto ??
                empleado.puesto ??
                "";


            const empleadoNormalizado = {

                IDEMPLEADO:
                    id,

                NOMBREEMPLEADO:
                    nombre,

                DPI:
                    dpi,

                DIRECCION:
                    direccion,

                NOMBREPUESTO:
                    puesto

            };


            const clave =
                String(id);


            if (
                !mapa.has(clave)
            ) {

                mapa.set(
                    clave,
                    empleadoNormalizado
                );

            }

        }
    );


    const resultado =
        Array.from(
            mapa.values()
        );


    // ========================================================
    // ORDEN ALFABÉTICO
    // ========================================================

    resultado.sort(
        function (a, b) {

            return String(
                a.NOMBREEMPLEADO ?? ""
            )
                .localeCompare(
                    String(
                        b.NOMBREEMPLEADO ?? ""
                    ),
                    "es",
                    {
                        sensitivity: "base"
                    }
                );

        }
    );


    return resultado;

}


// ============================================================
// CARGAR DROPDOWN DE EMPLEADOS
// ============================================================

function cargarDropdownEmpleados() {

    const selectEmpleado =
        document.getElementById(
            "idEmpleado"
        );


    if (!selectEmpleado) {

        console.error(
            "❌ NO EXISTE EL SELECT #idEmpleado"
        );

        return;

    }


    // ========================================================
    // IMPORTANTE:
    // HABILITAR EL SELECT
    // ========================================================

    selectEmpleado.disabled = false;

    selectEmpleado.removeAttribute(
        "disabled"
    );


    // ========================================================
    // LIMPIAR SELECT
    // ========================================================

    selectEmpleado.innerHTML = "";


    // ========================================================
    // OPCIÓN INICIAL
    // ========================================================

    const opcionInicial =
        document.createElement(
            "option"
        );


    opcionInicial.value = "";

    opcionInicial.textContent =
        "Seleccione un empleado";

    opcionInicial.disabled = true;

    opcionInicial.selected = true;


    selectEmpleado.appendChild(
        opcionInicial
    );


    // ========================================================
    // VALIDAR EMPLEADOS
    // ========================================================

    if (
        empleadosDepartamento.length === 0
    ) {

        const opcionSinEmpleados =
            document.createElement(
                "option"
            );


        opcionSinEmpleados.value = "";

        opcionSinEmpleados.textContent =
            "No hay empleados disponibles";


        selectEmpleado.appendChild(
            opcionSinEmpleados
        );


        // El select sigue habilitado.
        selectEmpleado.disabled = false;


        console.warn(
            "⚠️ NO HAY EMPLEADOS DISPONIBLES"
        );


        return;

    }


    // ========================================================
    // AGREGAR EMPLEADOS
    // ========================================================

    empleadosDepartamento.forEach(
        function (empleado) {

            const opcion =
                document.createElement(
                    "option"
                );


            const id =
                empleado.IDEMPLEADO ?? "";


            opcion.value =
                String(id);


            opcion.textContent =
                `${id} - ${
                    empleado.NOMBREEMPLEADO ?? ""
                }`;


            // =================================================
            // DATASET
            // =================================================

            opcion.dataset.id =
                String(
                    empleado.IDEMPLEADO ?? ""
                );


            opcion.dataset.nombre =
                String(
                    empleado.NOMBREEMPLEADO ?? ""
                );


            opcion.dataset.dpi =
                String(
                    empleado.DPI ?? ""
                );


            opcion.dataset.direccion =
                String(
                    empleado.DIRECCION ?? ""
                );


            opcion.dataset.puesto =
                String(
                    empleado.NOMBREPUESTO ?? ""
                );


            selectEmpleado.appendChild(
                opcion
            );

        }
    );


    // ========================================================
    // GARANTIZAR SELECT HABILITADO
    // ========================================================

    selectEmpleado.disabled = false;


    console.log(
        "✅ DROPDOWN CARGADO:",
        empleadosDepartamento.length,
        "empleados"
    );

}


// ============================================================
// ACTIVAR EVENTO DEL DROPDOWN
// ============================================================

function activarEventoEmpleado() {

    const selectEmpleado =
        document.getElementById(
            "idEmpleado"
        );


    if (!selectEmpleado) {

        console.error(
            "❌ NO EXISTE #idEmpleado"
        );

        return;

    }


    if (
        selectEmpleado.dataset.eventoActivo ===
        "true"
    ) {

        return;

    }


    selectEmpleado.dataset.eventoActivo =
        "true";


    selectEmpleado.addEventListener(
        "change",
        function () {

            const idEmpleado =
                selectEmpleado.value;


            console.log(
                "👤 EMPLEADO SELECCIONADO:",
                idEmpleado
            );


            if (!idEmpleado) {

                limpiarDatosEmpleado();

                return;

            }


            const opcionSeleccionada =
                selectEmpleado.options[
                    selectEmpleado.selectedIndex
                ];


            if (!opcionSeleccionada) {

                limpiarDatosEmpleado();

                return;

            }


            const empleado = {

                IDEMPLEADO:
                    opcionSeleccionada.dataset.id,

                NOMBREEMPLEADO:
                    opcionSeleccionada.dataset.nombre,

                DPI:
                    opcionSeleccionada.dataset.dpi,

                DIRECCION:
                    opcionSeleccionada.dataset.direccion,

                NOMBREPUESTO:
                    opcionSeleccionada.dataset.puesto

            };


            console.log(
                "📋 DATOS DEL EMPLEADO:",
                empleado
            );


            llenarDatosEmpleado(
                empleado
            );

        }
    );

}


// ============================================================
// LLENAR DATOS DEL EMPLEADO
// ============================================================

function llenarDatosEmpleado(
    empleado
) {

    colocarValor(
        "mostrarIdEmpleado",
        empleado.IDEMPLEADO
    );


    colocarValor(
        "nombreEmpleado",
        empleado.NOMBREEMPLEADO
    );


    colocarValor(
        "dpiEmpleado",
        empleado.DPI
    );


    colocarValor(
        "puestoEmpleado",
        empleado.NOMBREPUESTO
    );


    colocarValor(
        "direccionEmpleado",
        empleado.DIRECCION
    );

}


// ============================================================
// COLOCAR VALOR
// ============================================================

function colocarValor(
    id,
    valor
) {

    const campo =
        document.getElementById(
            id
        );


    if (!campo) {

        console.warn(
            `⚠️ NO EXISTE #${id}`
        );

        return;

    }


    campo.value =
        valor ?? "";

}


// ============================================================
// LIMPIAR DATOS EMPLEADO
// ============================================================

function limpiarDatosEmpleado() {

    const campos = [

        "mostrarIdEmpleado",

        "nombreEmpleado",

        "dpiEmpleado",

        "puestoEmpleado",

        "direccionEmpleado"

    ];


    campos.forEach(
        function (id) {

            const campo =
                document.getElementById(
                    id
                );


            if (campo) {

                campo.value = "";

            }

        }
    );

}


// ============================================================
// ACTIVAR FORMULARIO INSERTAR
// ============================================================

function activarFormularioDepartamento() {

    const formulario =
        document.getElementById(
            "formDepartamento"
        );


    if (!formulario) {

        console.warn(
            "⚠️ NO EXISTE #formDepartamento"
        );

        return;

    }


    if (
        formulario.dataset.eventoActivo ===
        "true"
    ) {

        return;

    }


    formulario.dataset.eventoActivo =
        "true";


    formulario.addEventListener(
        "submit",
        async function (evento) {

            evento.preventDefault();

            await insertarDepartamento();

        }
    );

}


// ============================================================
// INSERTAR
// ============================================================

async function insertarDepartamento() {

    try {

        const selectDepartamento =
            document.getElementById(
                "departamentoTecnologico"
            );


        const selectEmpleado =
            document.getElementById(
                "idEmpleado"
            );


        if (!selectDepartamento) {

            throw new Error(
                "No existe el departamento tecnológico."
            );

        }


        if (
            !selectDepartamento.value
        ) {

            throw new Error(
                "Debe seleccionar un departamento tecnológico."
            );

        }


        if (!selectEmpleado) {

            throw new Error(
                "No existe el dropdown de empleados."
            );

        }


        if (!selectEmpleado.value) {

            throw new Error(
                "Debe seleccionar un empleado."
            );

        }


        const campoFecha =
            document.getElementById(
                "fechaRegistro"
            );


        const fechaRegistro =
            campoFecha &&
            campoFecha.value
                ? campoFecha.value
                : obtenerFechaActual();


        const campoEstado =
            document.getElementById(
                "estadoDepartamento"
            );


        const estado =
            campoEstado &&
            campoEstado.value
                ? campoEstado.value
                : "A";


        const datos = {

            nombreTecnologico:
                selectDepartamento.value,

            fechaRegistro:
                fechaRegistro,

            estado:
                estado,

            idEmpleado:
                parseInt(
                    selectEmpleado.value,
                    10
                )

        };


        console.log(
            "📤 INSERTAR:",
            datos
        );


        const respuesta =
            await fetch(
                `${RUTA_DEPARTAMENTO}/insertar`,
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const resultado =
            await respuesta.json();


        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                resultado.error ||
                "No se pudo registrar el departamento."
            );

        }


        alert(
            "Departamento tecnológico registrado correctamente."
        );


        cerrarModalDepartamento();

        limpiarFormularioDepartamento();

        await cargarDatos();

    }
    catch (error) {

        console.error(
            "❌ ERROR INSERTANDO:",
            error
        );


        alert(
            error.message
        );

    }

}


// ============================================================
// FECHA ACTUAL
// ============================================================

function obtenerFechaActual() {

    const fecha =
        new Date();


    const año =
        fecha.getFullYear();


    const mes =
        String(
            fecha.getMonth() + 1
        )
            .padStart(
                2,
                "0"
            );


    const dia =
        String(
            fecha.getDate()
        )
            .padStart(
                2,
                "0"
            );


    return `${año}-${mes}-${dia}`;

}


// ============================================================
// CERRAR MODAL INSERTAR
// ============================================================

function cerrarModalDepartamento() {

    const modal =
        document.getElementById(
            "modalDepartamento"
        );


    if (
        !modal ||
        typeof bootstrap === "undefined"
    ) {

        return;

    }


    const instancia =
        bootstrap.Modal.getInstance(
            modal
        );


    if (instancia) {

        instancia.hide();

    }

}


// ============================================================
// LIMPIAR FORMULARIO
// ============================================================

function limpiarFormularioDepartamento() {

    const formulario =
        document.getElementById(
            "formDepartamento"
        );


    if (formulario) {

        formulario.reset();

    }


    limpiarDatosEmpleado();


    const selectEmpleado =
        document.getElementById(
            "idEmpleado"
        );


    if (selectEmpleado) {

        selectEmpleado.selectedIndex = 0;

        selectEmpleado.disabled = false;

    }

}


// ============================================================
// RENDERIZAR TABLA
// ============================================================

function renderizarTabla() {

    const tbody =
        document.getElementById(
            "tbodyDepartamentoTecnologico"
        );


    if (!tbody) {

        console.error(
            "❌ NO EXISTE #tbodyDepartamentoTecnologico"
        );

        return;

    }


    tbody.innerHTML = "";


    if (
        registrosDepartamento.length === 0
    ) {

        tbody.innerHTML = `

            <tr>

                <td
                    colspan="7"
                    class="text-center py-4"
                >

                    <i
                        class="bi bi-inbox fs-2 d-block mb-2"
                    ></i>

                    <div>
                        No hay departamentos tecnológicos registrados.
                    </div>

                </td>

            </tr>

        `;

        return;

    }


    registrosDepartamento.forEach(
        function (registro) {

            const idDepartamento =
                registro.IDDEPARTEMENTOTECNO ??
                registro.IDDEPARTAMENTOTECNOLOGICO ??
                "";


            const nombreCompleto =
                registro["NOMBRE COMPLETO"] ??
                registro.NOMBREEMPLEADO ??
                "";


            const dpi =
                registro.DPI ??
                "";


            const nombrePuesto =
                registro.NOMBREPUESTO ??
                "";


            const departamentoTecnologico =
                registro[
                    "DEPARTAMENTO TECNOLOGICO"
                ] ??
                registro.NOMBRETECNOLOGICO ??
                "";


            const fechaRegistro =
                registro.FECHAREGISTRO ??
                "";


            const fila =
                document.createElement(
                    "tr"
                );


            fila.innerHTML = `

                <td>
                    ${escapeHTML(
                        idDepartamento
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        nombreCompleto
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        dpi
                    )}
                </td>

                <td>
                    ${escapeHTML(
                        nombrePuesto
                    )}
                </td>

                <td>

                    <span
                        class="badge bg-success"
                    >

                        ${escapeHTML(
                            departamentoTecnologico
                        )}

                    </span>

                </td>

                <td>

                    ${formatearFecha(
                        fechaRegistro
                    )}

                </td>

                <td class="text-center">

                    <div
                        class="btn-group"
                        role="group"
                    >

                        <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            title="Editar"
                            onclick="abrirModalEditarDepartamento(${idDepartamento})"
                        >

                            <i
                                class="bi bi-pencil-square"
                            ></i>

                        </button>


                        <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            title="Eliminar"
                            onclick="abrirModalEliminarDepartamento(${idDepartamento})"
                        >

                            <i
                                class="bi bi-trash"
                            ></i>

                        </button>

                    </div>

                </td>

            `;


            tbody.appendChild(
                fila
            );

        }
    );

}


// ============================================================
// ACTUALIZAR RESUMEN
// ============================================================

function actualizarResumen() {

    const totalDepartamentos =
        document.getElementById(
            "totalDepartamentos"
        );


    if (totalDepartamentos) {

        totalDepartamentos.textContent =
            registrosDepartamento.length;

    }


    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    if (totalEmpleados) {

        const empleados =
            new Set();


        registrosDepartamento.forEach(
            function (registro) {

                const id =
                    registro.IDEMPLEADO ??
                    registro["NOMBRE COMPLETO"];


                if (id) {

                    empleados.add(
                        id
                    );

                }

            }
        );


        totalEmpleados.textContent =
            empleados.size;

    }


    const totalPuestos =
        document.getElementById(
            "totalPuestos"
        );


    if (totalPuestos) {

        const puestos =
            new Set();


        registrosDepartamento.forEach(
            function (registro) {

                const puesto =
                    registro.NOMBREPUESTO;


                if (puesto) {

                    puestos.add(
                        puesto
                    );

                }

            }
        );


        totalPuestos.textContent =
            puestos.size;

    }


    const totalRegistros =
        document.getElementById(
            "totalRegistros"
        );


    if (totalRegistros) {

        totalRegistros.textContent =
            registrosDepartamento.length;

    }

}


// ============================================================
// BUSCADOR
// ============================================================

function activarBuscador() {

    const buscador =
        document.getElementById(
            "buscarDepartamento"
        );


    if (!buscador) {

        return;

    }


    if (
        buscador.dataset.eventoActivo ===
        "true"
    ) {

        return;

    }


    buscador.dataset.eventoActivo =
        "true";


    buscador.addEventListener(
        "input",
        function () {

            const texto =
                buscador.value
                    .trim()
                    .toLowerCase();


            const filas =
                document.querySelectorAll(
                    "#tbodyDepartamentoTecnologico tr"
                );


            filas.forEach(
                function (fila) {

                    const contenido =
                        fila.textContent
                            .toLowerCase();


                    fila.style.display =
                        contenido.includes(
                            texto
                        )
                            ? ""
                            : "none";

                }
            );

        }
    );

}


// ============================================================
// ERROR TABLA
// ============================================================

function mostrarErrorTabla(
    mensaje
) {

    const tbody =
        document.getElementById(
            "tbodyDepartamentoTecnologico"
        );


    if (!tbody) {

        return;

    }


    tbody.innerHTML = `

        <tr>

            <td
                colspan="7"
                class="text-center text-danger py-4"
            >

                <i
                    class="bi bi-exclamation-triangle fs-2 d-block mb-2"
                ></i>

                <div>
                    No se pudieron cargar los departamentos tecnológicos.
                </div>

                <small>
                    ${escapeHTML(
                        mensaje
                    )}
                </small>

            </td>

        </tr>

    `;

}


// ============================================================
// FORMATEAR FECHA
// ============================================================

function formatearFecha(
    fecha
) {

    if (!fecha) {

        return "";

    }


    if (
        typeof fecha === "string"
    ) {

        if (
            fecha.includes("T")
        ) {

            return fecha.split("T")[0];

        }


        return fecha;

    }


    return fecha;

}


// ============================================================
// ESCAPAR HTML
// ============================================================

function escapeHTML(
    valor
) {

    return String(
        valor ?? ""
    )

        .replaceAll(
            "&",
            "&amp;"
        )

        .replaceAll(
            "<",
            "&lt;"
        )

        .replaceAll(
            ">",
            "&gt;"
        )

        .replaceAll(
            '"',
            "&quot;"
        )

        .replaceAll(
            "'",
            "&#039;"
        );

}


// ============================================================
// ABRIR MODAL EDITAR
// ============================================================

window.abrirModalEditarDepartamento =
    function (
        idDepartamento
    ) {

        const registro =
            registrosDepartamento.find(
                function (item) {

                    return String(
                        item.IDDEPARTEMENTOTECNO
                    ) ===
                    String(
                        idDepartamento
                    );

                }
            );


        if (!registro) {

            alert(
                "No se encontró el departamento seleccionado."
            );

            return;

        }


        const modal =
            document.getElementById(
                "modalEditarDepartamento"
            );


        if (!modal) {

            console.error(
                "❌ NO EXISTE #modalEditarDepartamento"
            );

            return;

        }


        // ====================================================
        // ID
        // ====================================================

        colocarValor(
            "editarIDDepartamento",
            registro.IDDEPARTEMENTOTECNO
        );


        colocarValor(
            "editarIdDepartamentoMostrar",
            registro.IDDEPARTEMENTOTECNO
        );


        // ====================================================
        // DEPARTAMENTO
        // ====================================================

        const selectDepartamento =
            document.getElementById(
                "editarNombreTecnologico"
            );


        if (selectDepartamento) {

            selectDepartamento.value =
                registro[
                    "DEPARTAMENTO TECNOLOGICO"
                ] ??
                registro.NOMBRETECNOLOGICO ??
                "";

        }


        // ====================================================
        // FECHA
        // ====================================================

        colocarValor(
            "editarFechaRegistro",
            formatearFecha(
                registro.FECHAREGISTRO
            )
        );


        // ====================================================
        // EMPLEADO
        // ====================================================

        let empleadoEncontrado =
            null;


        if (
            registro.IDEMPLEADO !==
                undefined &&
            registro.IDEMPLEADO !==
                null
        ) {

            empleadoEncontrado =
                empleadosDepartamento.find(
                    function (empleado) {

                        return String(
                            empleado.IDEMPLEADO
                        ) ===
                        String(
                            registro.IDEMPLEADO
                        );

                    }
                );

        }


        if (!empleadoEncontrado) {

            const nombreRegistro =
                String(
                    registro[
                        "NOMBRE COMPLETO"
                    ] ?? ""
                )
                    .trim()
                    .toLowerCase();


            if (nombreRegistro) {

                empleadoEncontrado =
                    empleadosDepartamento.find(
                        function (empleado) {

                            return String(
                                empleado.NOMBREEMPLEADO
                            )
                                .trim()
                                .toLowerCase() ===
                                nombreRegistro;

                        }
                    );

            }

        }


        if (empleadoEncontrado) {

            colocarValor(
                "editarIDEmpleado",
                empleadoEncontrado.IDEMPLEADO
            );


            colocarValor(
                "editarIdEmpleadoMostrar",
                empleadoEncontrado.IDEMPLEADO
            );


            colocarValor(
                "editarNombreEmpleado",
                empleadoEncontrado.NOMBREEMPLEADO
            );


            colocarValor(
                "editarDpi",
                empleadoEncontrado.DPI
            );


            colocarValor(
                "editarPuesto",
                empleadoEncontrado.NOMBREPUESTO
            );

        }
        else {

            colocarValor(
                "editarIDEmpleado",
                registro.IDEMPLEADO ??
                ""
            );


            colocarValor(
                "editarIdEmpleadoMostrar",
                registro.IDEMPLEADO ??
                ""
            );


            colocarValor(
                "editarNombreEmpleado",
                registro[
                    "NOMBRE COMPLETO"
                ] ??
                ""
            );


            colocarValor(
                "editarDpi",
                registro.DPI ??
                ""
            );


            colocarValor(
                "editarPuesto",
                registro.NOMBREPUESTO ??
                ""
            );

        }


        // ====================================================
        // MOSTRAR MODAL
        // ====================================================

        if (
            typeof bootstrap === "undefined"
        ) {

            console.error(
                "❌ BOOTSTRAP NO ESTÁ DISPONIBLE"
            );

            return;

        }


        const instancia =
            bootstrap.Modal.getOrCreateInstance(
                modal
            );


        instancia.show();

    };


// ============================================================
// ACTIVAR FORMULARIO EDITAR
// ============================================================

function activarFormularioEditarDepartamento() {

    const formulario =
        document.getElementById(
            "formEditarDepartamento"
        );


    if (!formulario) {

        return;

    }


    if (
        formulario.dataset.eventoActivo ===
        "true"
    ) {

        return;

    }


    formulario.dataset.eventoActivo =
        "true";


    formulario.addEventListener(
        "submit",
        async function (evento) {

            evento.preventDefault();

            await actualizarDepartamento();

        }
    );

}


// ============================================================
// ACTUALIZAR DEPARTAMENTO
// ============================================================

async function actualizarDepartamento() {

    try {

        const campoID =
            document.getElementById(
                "editarIDDepartamento"
            );


        const selectDepartamento =
            document.getElementById(
                "editarNombreTecnologico"
            );


        const campoFecha =
            document.getElementById(
                "editarFechaRegistro"
            );


        const campoEmpleado =
            document.getElementById(
                "editarIDEmpleado"
            );


        if (
            !campoID ||
            !campoID.value
        ) {

            throw new Error(
                "No se encontró el ID del departamento."
            );

        }


        if (
            !selectDepartamento ||
            !selectDepartamento.value
        ) {

            throw new Error(
                "Debe seleccionar un departamento tecnológico."
            );

        }


        if (
            !campoEmpleado ||
            !campoEmpleado.value
        ) {

            throw new Error(
                "No se encontró el empleado del departamento."
            );

        }


        const idDepartamento =
            parseInt(
                campoID.value,
                10
            );


        const idEmpleado =
            parseInt(
                campoEmpleado.value,
                10
            );


        if (
            isNaN(idDepartamento)
        ) {

            throw new Error(
                "El ID del departamento no es válido."
            );

        }


        if (
            isNaN(idEmpleado)
        ) {

            throw new Error(
                "El ID del empleado no es válido."
            );

        }


        const datos = {

            idDepartamentoTecnologico:
                idDepartamento,

            nombreTecnologico:
                selectDepartamento.value,

            fechaRegistro:
                campoFecha &&
                campoFecha.value
                    ? campoFecha.value
                    : obtenerFechaActual(),

            estado:
                "A",

            idEmpleado:
                idEmpleado

        };


        console.log(
            "📤 ACTUALIZAR:",
            datos
        );


        const respuesta =
            await fetch(
                `${RUTA_DEPARTAMENTO}/actualizar`,
                {

                    method: "PUT",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const resultado =
            await respuesta.json();


        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                resultado.error ||
                "No se pudo actualizar el departamento."
            );

        }


        alert(
            "Departamento tecnológico actualizado correctamente."
        );


        cerrarModalEditarDepartamento();

        await cargarDatos();

    }
    catch (error) {

        console.error(
            "❌ ERROR ACTUALIZANDO:",
            error
        );


        alert(
            error.message
        );

    }

}


// ============================================================
// CERRAR MODAL EDITAR
// ============================================================

function cerrarModalEditarDepartamento() {

    const modal =
        document.getElementById(
            "modalEditarDepartamento"
        );


    if (
        !modal ||
        typeof bootstrap === "undefined"
    ) {

        return;

    }


    const instancia =
        bootstrap.Modal.getInstance(
            modal
        );


    if (instancia) {

        instancia.hide();

    }

}


// ============================================================
// ABRIR MODAL ELIMINAR
// ============================================================

window.abrirModalEliminarDepartamento =
    function (
        idDepartamento
    ) {

        const modal =
            document.getElementById(
                "modalEliminarDepartamento"
            );


        if (!modal) {

            console.error(
                "❌ NO EXISTE #modalEliminarDepartamento"
            );

            return;

        }


        const campoID =
            document.getElementById(
                "eliminarIDDepartamento"
            );


        if (campoID) {

            campoID.value =
                idDepartamento;

        }


        if (
            typeof bootstrap === "undefined"
        ) {

            console.error(
                "❌ BOOTSTRAP NO ESTÁ DISPONIBLE"
            );

            return;

        }


        const instancia =
            bootstrap.Modal.getOrCreateInstance(
                modal
            );


        instancia.show();

    };


// ============================================================
// ACTIVAR FORMULARIO ELIMINAR
// ============================================================

function activarFormularioEliminarDepartamento() {

    const formulario =
        document.getElementById(
            "formEliminarDepartamento"
        );


    if (!formulario) {

        return;

    }


    if (
        formulario.dataset.eventoActivo ===
        "true"
    ) {

        return;

    }


    formulario.dataset.eventoActivo =
        "true";


    formulario.addEventListener(
        "submit",
        async function (evento) {

            evento.preventDefault();

            await eliminarDepartamento();

        }
    );

}


// ============================================================
// ELIMINAR
// ============================================================

async function eliminarDepartamento() {

    try {

        const campoID =
            document.getElementById(
                "eliminarIDDepartamento"
            );


        if (
            !campoID ||
            !campoID.value
        ) {

            throw new Error(
                "No se encontró el ID del departamento."
            );

        }


        const idDepartamento =
            parseInt(
                campoID.value,
                10
            );


        if (
            isNaN(idDepartamento)
        ) {

            throw new Error(
                "El ID del departamento no es válido."
            );

        }


        const datos = {

            idDepartamentoTecnologico:
                idDepartamento

        };


        const respuesta =
            await fetch(
                `${RUTA_DEPARTAMENTO}/eliminar`,
                {

                    method: "DELETE",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const resultado =
            await respuesta.json();


        if (
            !respuesta.ok ||
            !resultado.ok
        ) {

            throw new Error(
                resultado.mensaje ||
                resultado.error ||
                "No se pudo eliminar el departamento."
            );

        }


        alert(
            "Departamento tecnológico eliminado correctamente."
        );


        cerrarModalEliminarDepartamento();


        campoID.value = "";


        await cargarDatos();

    }
    catch (error) {

        console.error(
            "❌ ERROR ELIMINANDO:",
            error
        );


        alert(
            error.message
        );

    }

}


// ============================================================
// CERRAR MODAL ELIMINAR
// ============================================================

function cerrarModalEliminarDepartamento() {

    const modal =
        document.getElementById(
            "modalEliminarDepartamento"
        );


    if (
        !modal ||
        typeof bootstrap === "undefined"
    ) {

        return;

    }


    const instancia =
        bootstrap.Modal.getInstance(
            modal
        );


    if (instancia) {

        instancia.hide();

    }

}

